import AppRoutes from '@/routes/AppRoutes';
import ComponentNavigation from '@/navigation/ComponentNavigation';
import { useSsoLogin } from '@gyandiksha/shared-ui/hooks';

const App = () => {
  // This will handle the ERP User SSO login process.
  const isERPUserLoginReady = useSsoLogin(window.location.pathname !== '/reset');

  if (!isERPUserLoginReady) {
    return null;
  }

  return (
    <div>
      <AppRoutes componentRoutes={ComponentNavigation} />
    </div>
  );
};

export default App;
